<template>
    <div class="notice-page">
        <div class="notice-page__nav" @click="$router.back()">
            <img src="@/assets/img/notice/icon-back.png" alt="">
            <span>{{ $t('notice.title') }}</span>
        </div>
        <FadeContent :blur="true" :duration="800">
            <article class="notice-page__card">
                <h1>{{ title }}</h1>
                <time>{{datetime.slice(0,10)}}</time>
                <p v-html="info"></p>
            </article>
        </FadeContent>
    </div>
</template>

<script>
import FadeContent from '@/components/FadeContent/FadeContent.vue';



import axios from 'axios'
import contractaa from '../contract/index.js'

export default {
    name: 'notice-page',
    components: { FadeContent },
    data(){
        return{
            title:'',
            datetime:'',
            info:''
        }
    },
    methods:{
        async getInfo(){
            let that = this
            let useraddr = this.$store.state.globalAddress
            let id = this.$route.query.id
            
            let axiosResult = await axios.get(contractaa.APIURL+'?cmd=newinfo&id='+id);
            if(axiosResult.status == 200){
                if(axiosResult.data.Status){
                    that.title = axiosResult.data.Data.Title
                    that.info = axiosResult.data.Data.Info
                    that.datetime = axiosResult.data.Data.addtime
                }
            }
        },
    },
    computed: {
        bodyParas() {
            return String(this.$t('notice.body') || '')
                .split(/\n/)
                .map((item) => item.trimEnd());
        },
        
    },
    mounted(){
        this.getInfo()
    }
};
</script>

<style lang="less" scoped>
.notice-page {
    padding: 15px 16px 24px;
    color: #101126;

    &__nav {
        height: 22px;
        display: flex;
        align-items: center;
        gap: 4px;

        img {
            width: 12px;
            height: 12px;
            display: block;
            flex-shrink: 0;
        }

        span {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #101126;
        }
    }

    &__card {
        margin-top: 15px;
        width: 343px;
        min-height: 587px;
        padding: 19px 16px 24px;
        background: #FFFFFF;
        border-radius: 14px;
        box-sizing: border-box;

        h1 {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
            color: #101126;
        }

        time {
            display: block;
            margin: 8px 0 21px;
            font-size: 12px;
            line-height: 12px;
            font-style: normal;
            color: rgba(16, 17, 38, 0.4);
        }

        p {
            margin: 0;
            font-size: 12px;
            line-height: 20px;
            color: rgba(16, 17, 38, 0.7);

            + p {
                margin-top: 8px;
            }
        }
    }
}
</style>
